import { render, staticRenderFns } from "./RankingLeftBar.vue?vue&type=template&id=286bbfeb&scoped=true"
import script from "./RankingLeftBar.vue?vue&type=script&lang=js"
export * from "./RankingLeftBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286bbfeb",
  null
  
)

export default component.exports